"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MagicHatFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_MagicHatFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.854.854a.5.5 0 0 0-.708-.708l-3.949 3.95A24.847 24.847 0 0 0 8 4C3.582 4 0 5.12 0 6.5c0 .79 1.171 1.494 3 1.952v5.745c0 .198.059.391.204.524C3.661 15.14 4.97 16 8 16c3.031 0 4.34-.861 4.796-1.279.145-.133.204-.326.204-.524V8.452c1.829-.458 3-1.162 3-1.952 0-.993-1.853-1.851-4.538-2.254L14.854.854ZM8.78 5.512l-.635.634a.5.5 0 1 0 .708.708l1.26-1.26C11.819 5.752 13 6.098 13 6.5c0 .552-2.239 1-5 1s-5-.448-5-1 2.239-1 5-1c.266 0 .526.004.78.012Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0c.108 0 .207.061.256.158l.528 1.058 1.058.528a.286.286 0 0 1 0 .512l-1.058.528-.528 1.058a.286.286 0 0 1-.512 0l-.528-1.058-1.058-.528a.286.286 0 0 1 0-.512l1.058-.528.528-1.058A.286.286 0 0 1 3 0ZM7.692.118a.214.214 0 0 0-.384 0l-.396.794-.794.396a.214.214 0 0 0 0 .384l.794.396.396.794a.214.214 0 0 0 .384 0l.396-.794.794-.396a.214.214 0 0 0 0-.384L8.088.912 7.692.118Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_MagicHatFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = MagicHatFill;
exports["default"] = _default;